import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ConsumablesMaster = React.lazy(() => import('.'));

export const consumablesMasterRoutes = [
  new Route({
    path: 'consumables-master',
    element: ConsumablesMaster,
    children: [],
  }),
];
